import { useSelector } from 'react-redux'

import { useAppSelector } from 'store/hooks'

import { isLinkedStudent, selectCurrentSeniorYear, selectPrinciplesYou, selectProfile } from '.'

export const useIsLinkedStudent = () => useSelector(isLinkedStudent)

export const usePrinciplesYou = () => useSelector(selectPrinciplesYou)

export const useHighSchoolData = () => {
  const hs = useAppSelector((state) => state.user.record?.HighSchool)
  return hs
}

export const useCurrentSeniorYear = () => useSelector(selectCurrentSeniorYear)

export const useStudentGraduationYear = () => {
  const profile = useSelector(selectProfile)
  return profile?.GraduationYear
}
